import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_USE_ASSETS_DOMAIN_FOR_SCRIPTS = createFcmDetails('corgi_use_assets_domain_for_scripts', {
	owner: 'FE Framework',
	context: 'Corgi server',
	description:
		'Enable to use the assets domain (e.g. https://assets.change.org) for corgi JS scripts instead of the default domain (e.g. https://www.change.org)',
	import: false,
});
